import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TokenResponse } from '../_core/_interface/tokenSelsforce';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SelseforceCommunicationService {



  // private tokenUrl = 'https://realize360.my.salesforce.com/services/oauth2/token';
  // private clientId = '3MVG9Xl3BC6VHB.bhMhXEMwM9v6N6yYK36LQHw6nNBWui1m6n7TCCAGmr_DIUiNRTjYPnnqdi38sN6YMpcQa5';
  // private clientSecret = 'ACBD48EC1E26A76F5B932611E7E1FDB333A75A6F22736AF5430CFFD48D93DDE1';
  // private username = 'info@spirikal.co.il';
  // private password = 'Sctp2@!cW@dcvv230d';

  // constructor(private http: HttpClient) { }

  // getAccessToken(): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //   });

  //   const body = new HttpParams()
  //     .set('grant_type', 'password')
  //     .set('client_id', this.clientId)
  //     .set('client_secret', this.clientSecret)
  //     .set('username', this.username)
  //     .set('password', this.password);

  //   return this.http.post(this.tokenUrl, body, { headers });
  // }
  // private tokenUrl = 'https://realize360.my.salesforce.com/services/oauth2/token';
  // private clientId = '3MVG9Xl3BC6VHB.bhMhXEMwM9v6N6yYK36LQHw6nNBWui1m6n7TCCAGmr_DIUiNRTjYPnnqdi38sN6YMpcQa5';
  // private clientSecret = 'ACBD48EC1E26A76F5B932611E7E1FDB333A75A6F22736AF5430CFFD48D93DDE1';
  // private username = 'info@spirikal.co.il';
  // private password = 'Sctp2@!cW@dcvv230d';

  constructor(private http: HttpClient) { }

  getAccessToken(clientId, clientSecret, username, password, tokenUrl): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('client_id', clientId)
      .set('client_secret', clientSecret)
      .set('username', username)
      .set('password', password);

    return this.http.post(tokenUrl, body, { headers });
  }






  refreshTokenAndGetResponse(buildingId) {
    return this.refreshToken().pipe(
      switchMap(response => {
        console.log('Response from Salesforce:', response);
        let accessToken = response.access_token;
        return this.queryProperties(accessToken, buildingId);
      })
    );
  }  

  queryData(accessToken: string, queryUrlFromDb:any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${accessToken}`
    });
    // let buildingId = 'a01Wr000003nJz3IAE'
    // const queryUrl = "https://power-page-8818--dev.sandbox.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Id+=+'a02Wr000002Ow9lIAC'"
    
    // const queryUrl = "https://power-page-8818--dev.sandbox.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Project__c+=+'a06Wr000002bKhlIAE'"
    // const queryUrl = "https://power-page-8818--dev.sandbox.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Project__c+=+"+"'"+ buildingId +"'"+'"'
    // const queryUrl = "https://power-page-8818--dev.sandbox.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Project__c+=+'a01Wr000003nJz3IAE'"
    // const queryUrl = "https://power-page-8818--dev.sandbox.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Project__c+=+"+ "'" + buildingId + "'"
    // const queryUrl = "https://power-page-8818--dev.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE"
    
//  const queryUrl = "https://realize360.my.salesforce.com/services/data/v60.0/query?q=Select+Id,+Name,+Asset_Status__c,+Building__r.Name,+Project__r.Name,+Apt_No__c,+Floor__c,+Aprt_Size__c,+Porch_Size__c,+Rooms__c+FROM+Project_Line_Item__c+WHERE+Spirikal_Integration__c+=+TRUE+AND+Project__c+=+'a01Hp00001ILtGhIAL'"
 const queryUrl = queryUrlFromDb;



    return this.http.get(queryUrl, { headers });
  }



  refreshToken() {
    const url = 'https://carassorealestate.my.salesforce.com/services/oauth2/token';

    // Подготовка данных для тела запроса
    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('refresh_token', '5Aep8618d42zULhmmNUcoCwPsFNMdEEOqNxA4EdOaiTRF1zBYxOmZSpKc71WLtvIzSVy112.DYjWOTnVqIiDLzr');
    body.set('client_id', '3MVG9I9urWjeUW04nMmxsfMT0hdcUnxAZB56dRWNTlq.Dswmen6ZsSxKX_0AvO0u8V9NNxVKbSgiERXSFa0jo');
    body.set('client_secret', 'BE5E561764A6C352ED482804B2FA25DE56EDE40F8BF9506D605406EAC2F321B4');

    // Настройка заголовков
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    // Отправка запроса
    return this.http.post<TokenResponse>(url, body.toString(), { headers });
  }


  queryProperties(accessToken: string, buildingId: string): Observable<any> {
       const endpointUrl = "https://carassorealestate.my.salesforce.com/services/data/v56.0/query/?q=select Id,name, Property_Number__c, Building__r.Name, Asset_Purchasing_Status__c from Property__c where Available_For_Purchase_Spirikal__c  = TRUE and Building__c  = " + "'" + buildingId + "'";

    // Prepare the headers
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    });
  
    // Make the GET request
    return this.http.get(endpointUrl, { headers });
  }
}
